var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconUndo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#ffe9fe;opacity:0;}.b{fill:none;stroke:#070203;stroke-linecap:round;stroke-miterlimit:10;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-73 -237)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 24,
    height: 24,
    transform: "translate(73 237)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(77.476 242)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1.395,4.755h8.756a4.666,4.666,0,1,1,0,9.332H5.533",
    transform: "translate(-0.36 -1.228)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M4.007.353l-3.3,3.3,3.3,3.3",
    transform: "translate(-0.183 -0.091)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconUndo);
export default __webpack_public_path__ + "static/media/icon_undo.01beefb6d80fe68085ae67a5ac819000.svg";
export { ForwardRef as ReactComponent };